document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".complete-look").forEach((block) => {

    const sizes = block.querySelectorAll(".complete-look__size");
    const addBtn = block.querySelector(".complete-look__add");

    let selectedVariant = block.querySelector(".complete-look__size.is-active")?.dataset.variantId;

    sizes.forEach((btn) => {

      btn.addEventListener("click", () => {

        sizes.forEach(b => b.classList.remove("is-active"));

        btn.classList.add("is-active");

        selectedVariant = btn.dataset.variantId;

      });

    });

    addBtn.addEventListener("click", async () => {

  if (!selectedVariant) return;

  addBtn.disabled = true;

  try {

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: selectedVariant,
        quantity: 1,
        sections: ["cart-drawer", "cart-counter"],
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer) {
      cartDrawer.renderContents(data);
    }

  } catch (e) {
    console.error(e);
    alert("No fue posible agregar el producto.");
  }

  addBtn.disabled = false;

});

  });

});